module.exports = __webpack_public_path__ + "img/b73a9f8.jpg";